import {create_sharing_links} from '@massimo-cassandro/sharing-links/sharing-links';

export default function () {
  // attivazione sharing links

  document.querySelectorAll('.news-sharing').forEach(btn => {
    const news_card = btn.closest('.news-card'),
      url = btn.dataset.url;

    let sharing_links_container = news_card.querySelector('.news-sharing-links');

    btn.addEventListener('click', () => {
      if(!sharing_links_container) {
        news_card.insertAdjacentHTML('beforeend',
          `<div class="news-sharing-links">
            <button type="button" class="btn-close" aria-label="Chiudi"></button>
            <div></div>
          </div>`
        );
        sharing_links_container = news_card.querySelector('.news-sharing-links');
        create_sharing_links(
          sharing_links_container.querySelector(':scope > div'),
          {
            sharing: ['fb', 'twt', 'lnkd', 'wa'],
            size: 'small',
            title: 'Condividi con [[NAME]]',
            share_icon: false,
            url: url
          }
        );

        sharing_links_container.querySelector('.btn-close').addEventListener('click', () => {
          sharing_links_container.classList.remove('open');
        }, false);
      }

      sharing_links_container.classList.toggle('open');

    }, false); // end click
  }); // end foreach
}
